import makeRequest from './client';

export const getAllSourcesStatistics = () => makeRequest('/data_quality/statistics', 'GET');

export const getEsIndexValidationProcessDetails = (source: string, validationType: string) => {
  return makeRequest(`/data_quality/statistics/${source}/${validationType}`, 'GET');
};
